module.exports = __webpack_public_path__ + "img/IMG_8256.d3ec7439.jpg";